import type { ComponentProps } from "react"

export type UiIconName =
  | '_schema'
  | 'alert'
  | 'analytics'
  | 'arrow-down'
  | 'arrow-right'
  | 'arrow-up'
  | 'avatar'
  | 'bars'
  | 'bell'
  | 'billing'
  | 'book'
  | 'branch'
  | 'calendar'
  | 'changelog'
  | 'chat'
  | 'check'
  | 'checks'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'circle-stroke'
  | 'clock'
  | 'close'
  | 'code-circle'
  | 'collapse'
  | 'comment'
  | 'copy'
  | 'danger-zone'
  | 'database'
  | 'deployments'
  | 'discord'
  | 'discussion'
  | 'documentation'
  | 'domain'
  | 'dot'
  | 'download'
  | 'edit2'
  | 'ellipsis-vertical'
  | 'enter-key'
  | 'env-vars'
  | 'expand'
  | 'external-link'
  | 'eye'
  | 'fail'
  | 'federated'
  | 'file-upload'
  | 'filter'
  | 'folder'
  | 'four-diamonds'
  | 'gear'
  | 'git-commit'
  | 'git'
  | 'github'
  | 'graphql'
  | 'hamburger'
  | 'headset'
  | 'history'
  | 'home'
  | 'information'
  | 'integrations'
  | 'invoices'
  | 'key'
  | 'link'
  | 'lock'
  | 'logs'
  | 'magnifying-glass'
  | 'mail'
  | 'mark-as-read'
  | 'minus-smooth'
  | 'minus'
  | 'moon'
  | 'nexus'
  | 'organization'
  | 'pathfinder'
  | 'pathfinder2'
  | 'pause'
  | 'pencil'
  | 'pin-remove'
  | 'pin'
  | 'play'
  | 'plus-circle'
  | 'plus'
  | 'proposals'
  | 'refresh'
  | 'schema'
  | 'settings'
  | 'shield-lock'
  | 'side-panel'
  | 'sort'
  | 'split-diff'
  | 'standalone'
  | 'star'
  | 'subgraphs'
  | 'success'
  | 'sun'
  | 'terminal'
  | 'traces'
  | 'trash'
  | 'unified-diff'
  | 'user'
  | 'users'
  | 'window'

export function UiIconSvg({ assetName, basePath="", ...props }: { assetName: string, basePath?: string } & ComponentProps<'svg'>) {
  return (
    <svg {...props}>
      <use href={`${basePath}/sprites/ui-icon-sprite.db69da50.svg#asset-${assetName}`} />
    </svg>
  )
}
